<template>
  <div :id="divId">
    <v-row class="mx-auto">
      <v-col cols="12">
        <span style="color: rgba(0, 0, 0, 0.54); font-size: 15px">{{ titulo }}</span>
      </v-col>
      <v-col v-if="$slots['after-title']" cols="12">
        <slot name="after-title" />
      </v-col>

      <v-col cols="12">
        <v-select
          v-model="_campos[parametro].origem"
          :items="_campos[parametro].origemList"
          label="Origem"
          :placeholder="`Selecione a origem do ${nomeParametro}`"
          outlined
        />
      </v-col>
    </v-row>
    <v-row v-if="_campos[parametro].origem == 'existente'" class="mx-auto">
      <v-col cols="12">
        <validation-provider v-slot="{ errors }" rules="required">
          <v-text-field
            :label="nomeParametro"
            :placeholder="`Selecione uma ${nomeParametro}`"
            :value="value | valueSelected(items, campos[parametro].id)"
            readonly
            outlined
            :success="campos.headerValido"
            :error-messages="errors"
            @focus.close="
              {
                dialog = true;
              }
            "
          />
        </validation-provider>
        <general-saneamento-voc :tipo="nomeParametro" :activated.sync="dialog" @selected="selectedItem($event)" />
      </v-col>
    </v-row>

    <v-row v-if="_campos[parametro].origem == 'novo'" class="mx-auto">
      <v-col v-if="_campos[parametro].arquivo.fakeFile === false" cols="12" class="py-0">
        <validation-provider
          v-slot="{ errors }"
          :rules="{ required: true, excluded: items.map((item) => item.nome) }"
          :customMessages="{ excluded: 'Esse nome já existe' }"
        >
          <v-text-field
            v-model="_campos[parametro].nome"
            :label="`Nome ${nomeParametro}`"
            outlined
            :error-messages="errors"
            class="my-0"
          />
        </validation-provider>
      </v-col>
      <v-col cols="12" class="pb-0 pl-2">
        <validation-provider v-slot="{ errors }" rules="required">
          <v-file-input
            v-model="_campos[parametro].arquivo.fileObj"
            label="Arquivo CSV"
            placeholder="Selecione um arquivo CSV"
            outlined
            accept=".csv"
            :show-size="!_campos[parametro].arquivo.fakeFile"
            truncate-length="30"
            :loading="_campos[parametro].arquivo.uploading"
            loader-height="4"
            :success="arquivoValidado"
            :error-messages="errors"
            @change="uploadNewFile(_campos[parametro].arquivo)"
          />
        </validation-provider>

        <validation-provider rules="required">
          <input type="hidden" :value="arquivoValidado" />
        </validation-provider>
      </v-col>
    </v-row>

    <parametros-arquivo-csv
      v-if="_campos[parametro].origem == 'novo'"
      :delimitador.sync="_campos[parametro].arquivo.delimitador"
      :involucro.sync="_campos[parametro].arquivo.involucro"
      :escape.sync="_campos[parametro].arquivo.escape"
    />
  </div>
</template>

<script>
  import ArquivosService from '@/services/ArquivosService.js';
  import CmuService from '@/services/parametrosComCa/CmuService.js';
  import NormasTecnicasService from '@/services/parametrosComCa/NormasTecnicasService.js';
  import CadernosServicosService from '@/services/parametrosComCa/CadernosServicosService.js';

  export default {
    components: {
      ParametrosArquivoCsv: () => import('@/components/general/GeneralParametrosArquivoCsv.vue'),
      GeneralSaneamentoVoc: () => import('@/components/general/selectors/GeneralSaneamentoVoc.vue')
    },

    filters: {
      valueSelected(value, items, idSelected) {
        if (idSelected) {
          let selected = items.filter((element) => {
            return element.id == idSelected;
          });

          value = '#' + selected[0].id + ' - ' + selected[0].nome;
        }
        return value;
      }
    },

    props: {
      divId: {
        type: String,
        required: true
      },
      titulo: {
        type: String,
        required: true
      },
      nomeParametro: {
        type: String,
        required: true
      },
      parametro: {
        type: String,
        required: true
      },
      items: {
        type: Array,
        required: true
      },
      linkCadastros: {
        type: String,
        required: true
      },
      campos: {
        type: Object,
        required: true
      }
    },

    emits: ['update:campos'],

    data() {
      return {
        dialog: false,
        value: ''
      };
    },

    computed: {
      user() {
        return this.$store.getters.getUser;
      },
      _campos: {
        get() {
          return this.campos;
        },
        set(newValues) {
          this.$emit('update:campos', newValues);
        }
      },
      arquivoValidado() {
        if (
          this._campos[this.parametro].arquivo.id &&
          this._campos[this.parametro].arquivo.fileObj &&
          this._campos[this.parametro].arquivo.headerValido
        ) {
          return true;
        } else {
          return false;
        }
      }
    },

    methods: {
      uploadNewFile(arquivo) {
        if (!arquivo.fileObj) return;

        arquivo.fakeFile = false;
        arquivo.id = '';
        arquivo.uploading = true;
        arquivo.headerValido = false;

        let data = new FormData();
        data.append('file', arquivo.fileObj);

        ArquivosService.uploadFile(data)
          .then(async (response) => {
            arquivo.id = response.data.arquivoId;

            if (['cmu', 'normasTecnicas'].includes(this.parametro)) {
              await this.getValoresJson({
                arquivoId: arquivo.id,
                delimitador: arquivo.delimitador,
                involucro: arquivo.involucro,
                escape: arquivo.escape
              });
            } else if (this.parametro == 'cadernoServico') {
              await this.validaHeaderCadernoServico(arquivo.id, arquivo.delimitador, arquivo.involucro, arquivo.escape);
            }

            arquivo.headerValido = true;

            // Desseleciona o parametro existente caso o usuario tenha selecionado anteriormente
            this._campos[this.parametro].id = '';
          })
          .catch((err) => {
            console.error(err);

            if (err?.data?.error_code == 1001) {
              this.$toast.error(err.data.erro, '', { position: 'topRight', timeout: 6000 });
            } else {
              this.$toast.error('Erro no upload do arquivo.', '', { position: 'topRight' });
            }

            arquivo.fileObj = undefined;
          })
          .finally(() => {
            arquivo.uploading = false;
          });
      },

      getValoresJsonSistema({ idParametro }) {
        // Caderno de Serviço precisa apenas da referencia do ID
        if (this.parametro == 'cadernoServico') {
          return;
        }

        this.getValoresJson({ idParametro }).catch((err) => {
          console.error(err);
          this.$toast.error('Falha ao recuperar valores.', '', { position: 'topRight' });
          this._campos[this.parametro].id = '';
        });
      },
      /* Valida o Header do CMU ou Normas Técnicas (caso origem seja CSV) e retorna os valores dos parametros em JSON */
      getValoresJson({ arquivoId = '', delimitador = '', escape = '', involucro = '', idParametro = null }) {
        const Service = this.parametro == 'normasTecnicas' ? NormasTecnicasService : CmuService;

        return Service.getJsonValores({ arquivoId, delimitador, involucro, escape, idParametro })
          .then((res) => {
            this._campos[this.parametro].valores = res.data.json;
          })
          .catch((err) => {
            throw err;
          });
      },

      validaHeaderCadernoServico(arquivoId, delimitador, involucro, escape) {
        return CadernosServicosService.validarHeader({ arquivoId, delimitador, involucro, escape }).catch((err) => {
          throw err;
        });
      },

      formatData(date) {
        const dateformatJs = new Date(date);

        return dateformatJs.toLocaleString();
      },

      selectedItem($event) {
        this._campos[this.parametro].id = String($event.id);

        this.value = '#' + $event.id + ' - ' + $event.nome;

        this.dialog = false;
      }
    },

    watch: {
      value(value, oldValue) {
        if (value != oldValue) {
          this.getValoresJsonSistema({ idParametro: this._campos[this.parametro].id });
        }
      }
    }
  };
</script>

<style>

</style>